import axios from 'axios'
import config from '../config'
import { getPatientToken } from '../utils'

const getAppointmentHistoryApi = async() => {
    const response = await axios({
        url: `${config.api.base_url}patient/past-appointments`,
        method: "get",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getPatientToken()}`
        }
    })
    return response
}

export default getAppointmentHistoryApi